export type UpstreamProvider = 'codex' | 'grok' | 'gemini' | 'claude';
export type AccountAuthStatus = 'connected' | 'expired' | 'unauthorized';
export type AccountAuthMethod =
  | 'api_key'
  | 'official_device'
  | 'official_browser'
  | 'server_login';
// Toolchain capabilities, not a claim that subscription credentials support a generic API.
export const accountAuthMethods: Record<
  UpstreamProvider,
  readonly AccountAuthMethod[]
> = {
  codex: ['api_key', 'official_device', 'server_login'],
  grok: ['api_key'],
  gemini: ['api_key'],
  claude: ['api_key', 'official_browser', 'server_login'],
};
export interface UpstreamAccount {
  id: string;
  provider: UpstreamProvider;
  displayName: string;
  maskedIdentity: string;
  authMethod: AccountAuthMethod;
  instanceId: string | null;
  profileRef: string | null;
  enabled: boolean;
  authStatus: AccountAuthStatus;
  authReason: string | null;
  authorizedAt: string | null;
  createdAt: string;
  lastUsedAt: string | null;
  bindings: { id: string; name: string }[];
  quotaRemaining: number | null;
  version: number;
}
export type AccountSort = 'displayName' | 'enabled' | 'authStatus' | 'authorizedAt';
export interface AccountListInput {
  page: number;
  pageSize: number;
  q?: string;
  provider?: UpstreamProvider;
  authStatus?: AccountAuthStatus;
  enabled?: 'enabled' | 'disabled';
  sort?: AccountSort;
  order?: 'asc' | 'desc';
}
export interface StartAccountConnectionInput {
  provider: UpstreamProvider;
  displayName: string;
  accountId?: string;
  method: AccountAuthMethod;
  apiKey?: string;
  instanceId?: string;
  profileRef?: string;
}
export interface AccountConnection {
  id: string;
  provider: UpstreamProvider;
  displayName: string;
  accountId: string | null;
  method: AccountAuthMethod;
  instanceId: string | null;
  profileRef: string | null;
  status: 'pending' | 'succeeded' | 'cancelled' | 'expired' | 'rejected';
  deviceCode: string | null;
  reason: string | null;
  expiresAt: string;
  identities: { id: string; label: string; maskedIdentity: string }[];
}
